import styled from "styled-components";

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const FilterGroup = styled.div`
  background-color: var(--primary-dark-100);
  border: 1px solid var(--primary-dark-100);
  border-radius: 8px;
  padding: 20px 29px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--primary-dark);
`;

export const FilterOption = styled.button`
  font-size: 16px;
  color: var(--primary-blue);
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease;
  background: none;
  border: none;
  text-align: left;
  padding: 8px 0px;
  border-radius: 6px;
  position: relative;

  &:hover {
    background-color: var(--primary-blue-50);
    color: var(--primary-blue);
  }

  &.active {
    background-color: var(--primary-blue);
    color: white;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(30, 34, 255, 0.2);
    padding: 8px 28px;
  }

  &.active::before {
    content: "✓";
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    font-weight: bold;
  }
`;

export const FilterToggleGroup = styled.div`
  background-color: var(--primary-dark-100);
  border: 1px solid var(--primary-dark-100);
  border-radius: 8px;
  padding: 20px 29px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const FilterToggleLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-blue);
  cursor: pointer;
`;

export const FilterToggleSwitch = styled.span`
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 38px;
    height: 22px;
    background: #e6eaff;
    border-radius: 11px;
    transition: background 0.2s;
  }

  &::after {
    content: "";
    position: absolute;
    left: 3px;
    top: 3px;
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(30, 34, 255, 0.08);
  }

  input:checked + &::before {
    background: var(--primary-blue);
  }

  input:checked + &::after {
    left: 19px;
    background: var(--primary-white);
  }
`;
